export class PasswordConst {
    public static specialCharAuthorized: string = '#?!@$%^&*-+=./,_';
    public static passwordValidregex: RegExp =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#?!@$%^&*\-+=./,_])[A-Za-z\d#?!@$%^&*\-+=./,_]{8,}$/;
    public static get specialCharAuthorizedDisplayable(): string {
        return PasswordConst.specialCharAuthorized.split('').join(' ');
    }
}
